<template>
	<div class="basis-page-cls">
		 <!-- <section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section> -->
		<section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 数据列表</span>
                <div class="btns">
                    <el-button @click.stop="handleCreate" type="primary" size="small" icon="el-icon-circle-plus-outline" class="right">新增</el-button>
                </div>
            </div>
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList">
					<template v-slot:brand="{ row }">
						<span v-for="(val, index) in row.brand.split(',')" :key="index">
							{{(config_data['brands'].filter(item => item.code === val).length > 0) ? (config_data['brands'].filter(item => item.code === val)[0]['name']) : val}}
						</span>
					</template>
						<template v-slot:supplier="{ row }">
						<span>{{config_data['suppliers'].filter(item => item.code === row.supplier).length > 0 ? config_data['suppliers'].filter(item => item.code === row.supplier)[0]['name'] : row.supplier}}</span>
					</template>	
				</table-pagination>
            </div>
        </section>
		<el-drawer 
            :title="dialog_status == 'create' ? '新增' : dialog_status == 'update' ? '修改' : '详情'" 
            :visible.sync="dialog_visible_touch_in"
            :wrapperClosable="false"
			:modal-append-to-body="false"
			size="600px"
            direction="rtl">
            <el-form :model="config_form" ref="config_form" labelPosition="right" autoComplete="on" labelWidth="120px">
				<el-form-item prop="brand" label="品牌：">
                    <el-select v-model="config_form.brand" :disabled="dialog_status == 'info'" placeholder="请选择品牌" style="width:450px;" multiple collapse-tags>
                        <el-option v-for="item in config_data['brands']" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item prop="configName" label="账户名称：" :rules="[{required: true, trigger: 'blur', message: '请输入账户名称'}]">
                    <el-input v-model="config_form.configName" :disabled="dialog_status == 'info'" placeholder="请输入账户名称" style="width:450px;" clearable></el-input>
                </el-form-item>
				<el-form-item prop="serviceId" label="账户ID：" :rules="[{required: true, trigger: 'blur', message: '请输入账户ID'}]">
                    <el-input v-model="config_form.serviceId" :disabled="dialog_status == 'info'" placeholder="请输入账户ID" style="width:450px;" clearable></el-input>
                </el-form-item>
				<el-form-item prop="supplier" label="供应商：" :rules="[{required: true, trigger: 'blur', message: '请选择供应商'}]">
                    <el-select v-model="config_form.supplier" :disabled="dialog_status == 'info'" placeholder="请选择供应商" style="width:450px;" collapse-tags>
                        <el-option v-for="item in config_data['suppliers']" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item prop="password" label="密码：" :rules="[{required: true, trigger: 'blur', message: '请输入密码'}]">
                    <el-input v-model="config_form.password" :disabled="dialog_status == 'info'" placeholder="请输入密码" style="width:450px;" clearable show-password></el-input>
                </el-form-item>
				<el-form-item prop="serviceCode" label="服务代码：">
                    <el-input v-model="config_form.serviceCode" :disabled="dialog_status == 'info'" placeholder="SPSC" style="width:450px;" clearable></el-input>
                </el-form-item>
				<el-form-item prop="serviceSa" label="源代码：">
                    <el-input v-model="config_form.serviceSa" :disabled="dialog_status == 'info'" placeholder="SA" style="width:450px;" clearable></el-input>
                </el-form-item>
                <el-divider v-if="dialog_status !== 'info'"></el-divider>
                <el-form-item  v-if="dialog_status !== 'info'" style="float: right;padding-right: 30px;">
                    <el-button @click="dialog_visible_touch_in = false">取 消</el-button>
                    <el-button @click.stop="handelSubmit" :loading="loading" type="primary">保 存</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>
	</div>
</template>

<script>
import { tableMixin } from "utils/mixins";
export default {
	mixins: [tableMixin],
	data() {
		return {
			column: [
				// {
				// 	label: '品牌', 
				// 	render: (h, scope) => {
				// 		return (
				// 			<div>{scope.row.brand ? scope.row.brand.replace(/[,]/g, ' ') : ''}</div>
				// 		)
				// 	}
				// },
				{label: '品牌', prop: 'brand', slotScope: true},
				{label: '账号名称', prop: 'configName'},
				{label: '供应商', prop: 'supplier', slotScope: true},
				{
					label: '账号ID', 
					render: (h, scope) => {
						return (
							<el-link onClick={() => this.handelView(scope.row)} type="primary" underline={false}>{scope.row.serviceId}</el-link>
						)
					}
				},
				{ 
					label: '状态', 
					render: (h, scope) => {
						return (
							<el-switch
								class="switch"
								onChange={() => this.switchStatus(scope.row, scope.$index)}
								v-model={scope.row.status}
								active-value='0'
								inactive-value='1'
								active-color='#13ce66'
								inactive-color="#ff4949"
								active-text='已启用'
								inactive-text='已停用'>
							</el-switch>
						)
					}
				},
				{
                    label: '操作',
                    prop: 'cation',
                    width: 100,
                    fixed: 'right',
					align: 'center',
                    render: (h, scope) => {
						return (
							<div>
								<el-link onClick={() => this.handelEdit(scope.row)} type="primary" underline={false}>修改</el-link>
								<el-divider direction="vertical"></el-divider>
								<el-link onClick={() => this.handleDelete(scope.row)} disabled={scope.row.status == '0'} type="danger" underline={false}>删除</el-link>
							</div>
						)
                    }
                }
			],
			filterHeader: [
				{ label: '工单模板', model: 'processName', type: 'input', default: '', placeholder: '请输入工单模板名称' },
				{ label: '品牌', model: 'brand', type: 'select', default: '', list: [] },
				{ label: '状态', model: 'enabled', type: 'select', default: '', list: [{ name: '未发布', id: false }, { name: '已发布', id: true }] },
			],
			listQuery: {
				pageNum: 1,
				pageSize: 10,
			},
			list: [],
			total: 0,
			config_data: {
				brands: [],
				suppliers: []
			},
			loading: false,
			dialog_visible_touch_in: false,
			dialog_status: 'create',
			config_form: {
				brand: [],
				configName: '',
				serviceId: '',
				password: '',
				serviceCode: '',
				serviceSa: '',
				supplier: '',
				status: ''
			}
		}
	},
	async created() {
		await this.getList();
		await this.getConfigData();
	},
	methods: {
		getList() {
			this.$api.apiPostSmsSettingsList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response['list'];
				this.total = response.total;
			});
		},
		handleCreate() {
			this.resetForm();
			this.dialog_visible_touch_in = true;
			this.dialog_status = 'create';
		},
		handelEdit(row) {
			this.resetForm();
			this.dialog_visible_touch_in = true;
			this.dialog_status = 'update';
			this.config_form = Object.assign(this.config_form, row);
			this.config_form['brand'] = this.config_form['brand'].split(',');
		},
		handleDelete(row) {
			this.$confirm('删除后，该账户无法正常使用，账户下的发送信息数据将会消失。是否继续?', '系统提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$api.apiPostSmsSettingsDelete({configId: row.configId}).then(response => {
					if(response.errcode != 0) return;
					this.$notify({
						title: "删除成功",
						offset: 70,
						type: "success"
					});
					this.getList();
				});
			}).catch(() => {});
		},
		handelSubmit() {
            this.$refs["config_form"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.$api.apiPostSmsSettingsTouchIn(this.config_form).then(response => {
						if(response.errcode != 0) return;
                        this.$notify({
                            title: "保存成功",
                            offset: 70,
                            type: "success"
                        });
                        this.dialog_visible_touch_in = false;
						this.loading = false;
                        this.getList();
                    }).catch(error => {
						this.loading = false;
					});
                }
            });
		},
		switchStatus(row, index) {
            this.$api.apiPostSmsSettingsStatus({configId: row.configId, status: row.status === '0' ? '0' : '1'}).then(response => {
				if(response.errcode != 0) return;
				this.$notify({
					title: `${row.status === '1' ? "停用" : "启用"}成功`,
					offset: 70,
					type: "success"
				});
				this.getList();
			}).catch(error => {
				this.list[index].status = row.status === '0' ? '1' : '0';
			});
        },
		handelView(row) {
			this.resetForm();
			this.dialog_visible_touch_in = true;
			this.dialog_status = 'info';
			this.config_form = Object.assign(this.config_form, row);
			this.config_form['brand'] = this.config_form['brand'].split(',');
		},
		resetForm() {
			this.config_form = {
				brand: [],
				configName: '',
				serviceId: '',
				password: '',
				serviceCode: '',
				serviceSa: '',
				supplier: '',
				status: ''
			}
			if (this.$refs["config_form"]) {
				this.$refs["config_form"].clearValidate();
			}
		},
		getConfigData() {
			this.$api.apiPostSmsConfigData(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.config_data = Object.assign(this.config_data, response.data);
			});
		},
		filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
			this.getList();
		}
	}
}
</script>
